import React from "react";

function ListHeadingComponent(props) {
    return(
        <h5 className={props.classname}>{props.headingName}</h5>
    
    );
    }
    
    export default ListHeadingComponent;